import './App.css'
import Account from './Account'

function App() {
  return (
    <div className="app-shell">
      <Account storageMode="local" />
    </div>
  )
}

export default App
